<template>
  <a-row class="administrator-layout">
    <a-col flex="250px" class="administrator-layout__left-side">
      <SideBar :items="sidebarItems" />
    </a-col>
    <a-col flex="auto" class="administrator-layout__right-side">
      <div class="administrator-layout__header">
        <HeaderPartnerAccount />
      </div>
      <div ref="scrollElement" class="administrator-layout__content">
        <slot></slot>
      </div>
    </a-col>
  </a-row>
</template>

<script setup>
  import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
  import SideBar from '@/components/sidebar/SideBar';
  import HeaderPartnerAccount from '@/components/header/HeaderPartnerAccount';
  import { debounce } from 'lodash-es';

  document.title = 'Цифровой университет. НГУ';

  const props = defineProps({
    requestCount: Number,
    projectCount: Number,
    showcaseCount: Number,
    spinning: {
      type: Boolean,
      default: false,
    },
  });

  const scrollThreshold = 30;
  const scrollElement = ref(null);
  const emit = defineEmits(['scroll-bottom']);

  // TODO - show for administrator right number on left SideBar
  // Path here - is name from router

  const sidebarItems = ref([
    {
      id: 1,
      text: 'Портфели',
      path: 'administrator-portfolios',
      hash: '#all',
      type: 'portfolios',
      count: 0,
      isCollapsed: true,
      submenu: [
        {
          id: 1,
          text: 'Все портфели',
          path: 'administrator-portfolios',
          hash: '#all',
          type: 'portfolios',
          count: 0,
        },
        {
          id: 2,
          text: 'Мои портфели',
          path: 'administrator-portfolios',
          hash: '#my',
          type: 'portfolios',
          count: 0,
        },
      ],
    },
    {
      id: 2,
      text: 'Запросы',
      path: 'administrator-requests',
      type: 'request',
      count: 0,
    },
    {
      id: 3,
      text: 'Мои проекты',
      path: 'administrator-projects',
      type: 'projects',
      count: 0,
    },
    {
      id: 4,
      text: 'Витрина',
      path: 'administrator-showcases',
      hash: '#published',
      type: 'showcases',
      count: 0,
    },
  ]);

  onMounted(async () => {
    scrollElement.value.addEventListener('scroll', handleScroll);
  });

  onBeforeUnmount(() => {
    scrollElement.value.removeEventListener('scroll', handleScroll);
  });

  watch(
    () => props.requestCount,
    () => {
      sidebarItems.value[1].count = props.requestCount;
      sidebarItems.value[1].hash = props.requestCount > 0 ? '#new' : '#inwork';
    }
  );

  watch(
    () => props.projectCount,
    () => {
      sidebarItems.value[2].count = props.projectCount;
      sidebarItems.value[2].hash = props.projectCount > 0 ? '#new' : '#inwork';
    }
  );

  watch(
    () => props.showcaseCount,
    () => {
      sidebarItems.value[3].count = props.showcaseCount;
      sidebarItems.value[3].hash =
        props.showcaseCount > 0 ? '#new' : '#published';
    }
  );

  const handleScroll = debounce(() => {
    const elementHeight = scrollElement.value?.getBoundingClientRect().height;
    const scrollHeight = scrollElement.value?.scrollHeight;
    const scrollBottom = scrollElement.value?.scrollTop + elementHeight;
    if (scrollBottom + scrollThreshold > scrollHeight) {
      emit('scroll-bottom', scrollBottom);
    }
  }, 70);
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .administrator-layout {
    min-height: 100vh;
    flex-wrap: nowrap;

    .administrator-layout__right-side {
      overflow: hidden;
      height: 100vh;
    }

    .administrator-layout__header {
      padding: 17px 40px 17px 20px;
      border-bottom: 1px solid $color-bg-secondary-grey;
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .administrator-layout__content {
      overflow-y: auto;
      height: 100%;
      padding: 30px 40px 100px 20px;
    }
  }
</style>
